import { PanelSiteDataType, SkuDataType } from './EditProduction.types'

export const roundNumber = (num: number) => {
  return Math.round((num + Number.EPSILON) * 100) / 100
}

export const innerTableReduce = (
  newRow: PanelSiteDataType,
  weeks: string[]
) => {
  weeks.reduce((acc: number, week: string) => {
    if (newRow[week]) {
      const cumulativeChangeInProduction =
        acc + newRow[week].changeInArrivalAmount
      const initialClosingInventory = newRow[week].initialClosingInventory ?? 0
      const salesRate = newRow[week].salesRate ?? 0
      const projectedClosingInventory =
        newRow[week].projectedClosingInventory ?? 0
      const targetCloseInventory = newRow[week].targetCloseInventory ?? 0
      const salesRatePerDay = roundNumber(salesRate / 7)
      const initialMinimumInventory = newRow[week].initialMinimumInventory ?? 0

      const projectedMinimumInventory = roundNumber(
        initialMinimumInventory + cumulativeChangeInProduction
      )
      const safetyStockVolume = newRow[week].safetyStockVolume ?? 0
      newRow[week].projectedMinimumInventory = projectedMinimumInventory

      if (projectedMinimumInventory < 0) {
        newRow[week].projectedStockOut = true
      }
      if (projectedMinimumInventory < safetyStockVolume) {
        newRow[week].projectedLowStock = true
      }

      newRow[week].cumulativeChangeInProduction = cumulativeChangeInProduction
      newRow[week].projectedClosingInventory = roundNumber(
        initialClosingInventory + cumulativeChangeInProduction
      )
      newRow[week].projectedClosingDays =
        salesRatePerDay !== 0
          ? roundNumber(
              newRow[week].projectedClosingInventory / salesRatePerDay
            )
          : 0
      newRow[week].inventoryExcess = roundNumber(
        projectedClosingInventory - targetCloseInventory
      )
      newRow[week].inventoryExcessDays =
        salesRatePerDay !== 0
          ? roundNumber(
              (projectedClosingInventory - targetCloseInventory) /
                salesRatePerDay
            )
          : 0
      return cumulativeChangeInProduction
    }
    return acc
  }, 0)
  return { ...newRow }
}

export const outerTableReduce = (
  newRow: SkuDataType,
  weeks: string[],
  proposedProductionAmount: number,
  runRate: number
) => {
  // Calculate cumulative change in production
  weeks.reduce((acc, week: string) => {
    if (newRow[week]) {
      const cumulativeChangeInProduction =
        acc + newRow[week].changeInProductionAmount
      const weekCloseInventoryInitial =
        newRow[week].weekCloseInventoryInitial ?? 0
      const targetCloseInventory = newRow[week].targetCloseInventory ?? 0
      const salesRate = newRow[week].salesRate ?? 0
      const inventoryEexcessProjected =
        weekCloseInventoryInitial +
        cumulativeChangeInProduction -
        targetCloseInventory

      newRow[week].changeInProductionHours = roundNumber(
        proposedProductionAmount / runRate - newRow[week].initialProductionHours
      )
      newRow[week].cumulativeChangeInProduction = cumulativeChangeInProduction
      newRow[week].weekCloseInventoryProjected = roundNumber(
        cumulativeChangeInProduction + weekCloseInventoryInitial
      )

      newRow[week].inventoryExcessProjected = inventoryEexcessProjected
      newRow[week].excessDaysProjected =
        salesRate !== 0
          ? roundNumber(inventoryEexcessProjected / (salesRate / 7))
          : 0
      newRow[week].targetCloseDays =
        salesRate !== 0
          ? roundNumber(targetCloseInventory) / (salesRate / 7)
          : 0
      newRow[week].weekCloseInventoryProjected = roundNumber(
        weekCloseInventoryInitial + cumulativeChangeInProduction
      )

      newRow[week].weekCloseDaysProjected =
        salesRate !== 0
          ? roundNumber(
              (weekCloseInventoryInitial + cumulativeChangeInProduction) /
                (salesRate / 7)
            )
          : 0
      return cumulativeChangeInProduction
    }
    return acc
  }, 0)

  return { ...newRow }
}
